module.exports = __webpack_public_path__ + "static/img/daetwiler.ddb6cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/daetwiler.png
// module id = 477
// module chunks = 1